export class ROUTE {
    public static LOGIN = '/login';
    public static AUTH0_CALLBACK = '/auth';
    public static LOGOUT = '/logout';

	public static DASHBOARD = '/';
	
    public static CANDIDATES = '/candidates';
    public static CANDIDATE: any = {
        DETAILED: `${ROUTE.CANDIDATES}/:id`, 
        VIEW: (id: number) => `${ROUTE.CANDIDATES}/${id}`
    };
    public static VACANCIES = '/vacancies';
    public static VACANCY: any = {
        DETAILED: `${ROUTE.VACANCIES}/:id`, 
        VIEW: (id: number) => `${ROUTE.VACANCIES}/${id}`
    };
    public static BUSINESSES = '/businesses';
    public static BUSINESS: any = {
        DETAILED: `${ROUTE.BUSINESSES}/:id`, 
        VIEW: (id: number) => `${ROUTE.BUSINESSES}/${id}`
    };
    public static BUSINESS_UNITS = '/business_units';
    public static BUSINESS_UNIT: any = {
        DETAILED: `${ROUTE.BUSINESS_UNITS}/:id`, 
        VIEW: (id: number) => `${ROUTE.BUSINESS_UNITS}/${id}`
    };
    public static CONTACTS = '/contacts';
    public static CONTACT: any = {
        DETAILED: `${ROUTE.CONTACTS}/:id`, 
        VIEW: (id: number) => `${ROUTE.CONTACTS}/${id}`
    };
    public static OFFERS = '/offers';
    public static OFFER: any = {
        DETAILED: `${ROUTE.OFFERS}/:id`, 
        VIEW: (id: number) => `${ROUTE.OFFERS}/${id}`
    };

    public static BLOG = '/blog';
    public static BLOG_ITEM: any = {
        DETAILED: `${ROUTE.BLOG}/:id`, 
        VIEW: (id: number) => `${ROUTE.BLOG}/${id}`
    };

    
    public static PROFILE = '/profile';

    public static CMS = 'https://cms.growing-people.nl';

    public static SETTINGS = '/instellingen';
    public static SETTING: any = {
        ENTITIES: ROUTE.SETTINGS + '/entities',
        MODULES: ROUTE.SETTINGS + '/modules',
        USERS: ROUTE.SETTINGS + '/users',

        LAYOUT: ROUTE.SETTINGS + '/layouts',
        FIELDS: ROUTE.SETTINGS + '/fields',
        DATASETS: ROUTE.SETTINGS + '/datasets',

        RELATIONS: ROUTE.SETTINGS + '/relations',
        SYNONYMS: ROUTE.SETTINGS + '/synonyms',

        MAILGUN: ROUTE.SETTINGS + '/mailgun'
    }
}

export const ROUTES = {
    DASHBOARD: {
        path: '/',
        title: 'Dashboard - Growing People App'
    },
    CREATE: {
        path: '/:entity_name/toevoegen',
        title: ':entity_name toevoegen - :entity_names - Growing People App',
        getFullPath: (id: string) => ROUTES.CREATE.path.replace(':entity_name', id)
    },
    MAILS: {
        path: '/mails',
        title: 'Mails - Growing People App',
        getFullPath: () => ROUTES.MAILS.path
    },
    OPTIONS: {
        path: '/shortlists',
        title: 'Shortlists - Growing People App',
        getFullPath: () => ROUTES.OPTIONS.path
    },
    VACANCIES: {
        path: '/vacatures',
        title: 'Vacatures - Growing People App',
        DETAILED: {
            path: '/:id',
            getFullPath: (id?: string) => ROUTES.VACANCIES.path + (id ? `/${id}` : ROUTES.VACANCIES.DETAILED.path),
        }
    },
    CANDIDATES: {
        path: '/kandidaten',
        title: 'Kandidaten - Growing People App',
        DETAILED: {
            path: '/:id',
            getFullPath: (id?: string) => ROUTES.CANDIDATES.path + (id ? `/${id}` : ROUTES.CANDIDATES.DETAILED.path),
        }
    },
    OFFERS: {
        path: '/aanbiedingen',
        title: 'Aanbiedingen - Growing People App',
        DETAILED: {
            path: '/:id',
            getFullPath: (id?: string) => ROUTES.OFFERS.path + (id ? `/${id}` : ROUTES.OFFERS.DETAILED.path),
        }
    },
    BUSINESS_UNITS: {
        path: '/bedrijven',
        title: 'Bedrijven - Growing People App',
        DETAILED: {
            path: '/:id',
            getFullPath: (id?: string) => ROUTES.BUSINESS_UNITS.path + (id ? `/${id}` : ROUTES.BUSINESS_UNITS.DETAILED.path),
        }
    },
    CONTACTS: {
        path: '/contactpersonen',
        title: 'Contactpersonen - Growing People App',
        DETAILED: {
            path: '/:id',
            getFullPath: (id?: string) => ROUTES.CONTACTS.path + (id ? `/${id}` : ROUTES.CONTACTS.DETAILED.path),
        }
    },
    BLOG: {
        path: '/blog',
        title: 'Blog - Growing People App',
        getFullPath: () => ROUTES.BLOG.path,
        DETAILED: {
            path: '/:id',
            getFullPath: (id?: string) => ROUTES.BLOG.path + (id ? `/${id}` : ROUTES.BLOG.DETAILED.path),
        },
        CREATE: {
            path: '/create',
            getFullPath: () => ROUTES.BLOG.path + ROUTES.BLOG.CREATE.path
        },
        EDIT: {
            path: '/edit/:id',
            getFullPath: (id?: string) => ROUTES.BLOG.path + (id ? `/edit/${id}` : ROUTES.BLOG.EDIT.path)
        }
    },
    PROFILE: {
        path: '/profiel',
        title: 'Profiel - Growing People App',
        getFullPath: () => ROUTES.PROFILE.path
    },
    SETTINGS: {
        path: '/instellingen',
        title: 'Instellingen - Growing People App',
        getFullPath: () => ROUTES.SETTINGS.path,
        GENERAL: {
            path: '/algemeen',
            getFullPath: () => ROUTES.SETTINGS.path + ROUTES.SETTINGS.GENERAL.path
        },
        EXTENSIONS: {
            path: '/extensies',
            getFullPath: () => ROUTES.SETTINGS.path + ROUTES.SETTINGS.EXTENSIONS.path
        },
        USERS: {
            path: '/gebruikers',
            getFullPath: () => ROUTES.SETTINGS.path + ROUTES.SETTINGS.USERS.path
        },
        ENTITIES: {
            path: '/entiteiten',
            getFullPath: () => ROUTES.SETTINGS.path + ROUTES.SETTINGS.ENTITIES.path,
            ENTITY: {
                path: '/:entity_id',
                getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.getFullPath() + (entity_id ? `/${entity_id}` : ROUTES.SETTINGS.ENTITIES.ENTITY.path),
                GENERAL: {
                    path: '/algemeen',
                    getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.GENERAL.path,
                },
                MODULES: {
                    path: '/modules',
                    getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.path,
                    CONTACT_MODULE: {
                        path: '/contact_module',
                        getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.CONTACT_MODULE.path,
                    },
                    NOTES: {
                        path: '/notities',
                        getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.NOTES.path,
                    },
                    DOCUMENT_GENERATOR: {
                        path: '/document_generator',
                        getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.DOCUMENT_GENERATOR.path,
                    },
                    FILES: {
                        path: '/bestanden',
                        getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.MODULES.FILES.path,
                    },
                },
                FIELDS: {
                    path: '/velden',
                    getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.FIELDS.path,
                },
                LAYOUTS: {
                    path: '/layouts',
                    getFullPath: (entity_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath(entity_id) + ROUTES.SETTINGS.ENTITIES.ENTITY.LAYOUTS.path,
                    TYPES: {
                        path: '/:type_id',
                        getFullPath: (entity_id?: string, type_id?: string) => ROUTES.SETTINGS.ENTITIES.ENTITY.LAYOUTS.getFullPath(entity_id) + (type_id ? `/${type_id}` : ROUTES.SETTINGS.ENTITIES.ENTITY.LAYOUTS.TYPES.path)
                    }
                }
            }
        },

        RELATIONS: {
            path: '/relaties',
            getFullPath: () => ROUTES.SETTINGS.path + ROUTES.SETTINGS.RELATIONS.path
        },
        DATASETS: {
            path: '/datasets',
            getFullPath: () => ROUTES.SETTINGS.path + ROUTES.SETTINGS.DATASETS.path
        }
    }
}